export default __webpack_public_path__ + "static/media/_login-slide-top.48eb7cc2.png";